<template>
    <span
        v-if="ratingNumber"
        class="tag mr-1 is-rounded is-font-small"
        style="float: right; width: fit-content"
        :style="{ 'background-color': ratingColor, color: 'rgba(0,0,0,0.8)' }"
        >Bewertung: {{ ratingNumber }}
    </span>
</template>

<script>
/**
 * Tag displaying the rating of a certain entryLink, tinted with the
 * Risikobewertung gradient (faint at 1, strong at 6). Unrated or
 * neutral entries show no tag.
 * @displayName RatingTag
 */

export default {
    name: "RatingTag",
    props: ["entryLink"],
	computed:{
		ratingNumber(){
			const value = Number(this.entryLink.attributes.rating);
			return isNaN(value) || value <= 0 ? 0 : Math.min(value, 6);
		},
		ratingColor(){
			// Same gradient as the assessment form, blended over white.
			const alpha = 0.06 + 0.84 * (this.ratingNumber - 1) / 5;
			const mix = (c) => Math.round(255 - (255 - c) * alpha);
			return "rgb(" + mix(239) + ", " + mix(110) + ", "
				+ mix(136) + ")";
		}
	}
};
</script>

<style scoped>
</style>
